import React from "react";
import { useTranslation } from "utilities/i18n";
import { useModalDispatch, DefaultModalForm } from "collections/Modal";
import { CancelButton, SubmitButton } from "elements";

export const DisableProvisioningModal: React.FC<{
  onDisable: () => any;
  isSubmitting: boolean;
}> = ({ onDisable, isSubmitting }) => {
  const { t } = useTranslation();
  const dispatchEvent = useModalDispatch();

  return (
    <DefaultModalForm
      title={t("DISABLE_PROVISIONING")}
      className="pt-2"
      onSubmit={() => onDisable()}
      name="DisableProvisioning"
    >
      <div className="small-text pt-1">
        {t("DISABLE_PROVISIONING_CONFIRMATION")}
      </div>
      <div className="btn-container">
        <CancelButton onClick={dispatchEvent} />
        <SubmitButton
          isSubmitting={isSubmitting}
          labelKey="DISABLE"
          submittingLabelKey="DISABLING"
        />
      </div>
    </DefaultModalForm>
  );
};
